import { gql } from 'apollo-boost';
import { FOLDER_CACHE_SAFE_FIELDS } from '../../fragments/folder/cache-safe-folder-fields';

export const GET_OWNED_SHARED_FOLDERS = gql`
    query getOwnedSharedFolders {
        getOwnedSharedFolders {
            shareCount
            isPublished
            updatedAt
            folder {
                ...FolderCacheSafeFields
            }
        }
    }
    ${FOLDER_CACHE_SAFE_FIELDS}
`;